import { graphql } from "react-relay";

export const AddJiraInstanceMutation = graphql`
  mutation AddJiraInstanceMutation($input: AddJiraInstanceInput!) {
    addJiraInstance(input: $input) {
      jiraInstance {
        defaultSpace {
          key
          name
        }
        defaultWorkType {
          name
        }
        error
        id
        spaces {
          ...JiraInstanceDefaultsFields_spaces
        }
        spacesUpdated
        updatePending
        clientId
        issueLimitSoft
        issueLimitHard
        name
        url
        username
        uuid
      }
      problems {
        message
      }
    }
  }
`;
